import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { SquareStackIcon, TrashIcon } from '@/icons';
import { ContextMenu } from '@/ui_v3';
export const WithSliderItemContextMenu = ({
  children,
  onCopy,
  onDelete
}: {
  children: React.ReactNode;
  onCopy: () => void;
  onDelete: () => void;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <ContextMenu.Root modal={false} data-sentry-element="unknown" data-sentry-component="WithSliderItemContextMenu" data-sentry-source-file="WithSliderItemContextMenu.tsx">
      <ContextMenu.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">{children}</ContextMenu.Trigger>
      <ContextMenu.Portal data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">
        <ContextMenu.Content data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">
          <ContextMenu.Item onSelect={() => {
          onCopy();
          logger.track('copy_quizItem', {
            position: 'sidebar_context_menu'
          });
        }} data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">
            <SquareStackIcon size="sm" fill={ICON_COLOR.default} data-sentry-element="SquareStackIcon" data-sentry-source-file="WithSliderItemContextMenu.tsx" />
            {t('global.duplicate.button')}
          </ContextMenu.Item>
          <ContextMenu.Item onSelect={onDelete} data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">
            <TrashIcon size="sm" fill={ICON_COLOR.default} data-sentry-element="TrashIcon" data-sentry-source-file="WithSliderItemContextMenu.tsx" />
            {t('global.delete')}
          </ContextMenu.Item>
        </ContextMenu.Content>
      </ContextMenu.Portal>
    </ContextMenu.Root>;
};